import * as React from 'react';
const SvgSupervisorStar = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <circle cx={8} cy={8} r={8} fill="#1270EC" />
        <path
            d="M8 10.424l-2.098 1.277a.325.325 0 01-.485-.353l.565-2.39L4.12 7.356a.325.325 0 01.185-.57l2.448-.201.947-2.266a.325.325 0 01.6 0l.948 2.266 2.447.201a.325.325 0 01.185.57l-1.862 1.602.566 2.39a.325.325 0 01-.486.353L8 10.424z"
            fill="#fff"
        />
    </svg>
);
export default SvgSupervisorStar;
